// Modules
import React, { useContext, useEffect, useState } from "react";
//@ts-ignore
import { LocalizationContext } from "react-localize";
// Styles
import "./CancelReservation.sass";
// Services
import ReservationService from "Services/reservation.service";
import { ScreenType } from "../../../Constants";
import { ReservationType } from "Interfaces/GetReservations";
import MvLoader from "Generic/MvLoader/MvLoader";
import { CancelReview } from "./CancelReview/CancelReview";
import { CancelConfirmation } from "./CancelConfirmation/CancelConfirmation";
import MvIcon from "Generic/MvIcon";

type Props = {
  token: string;
  lang: string;
  resId: number;
  resType: ReservationType;
  waitListId?: number;
  setScreenType(screenType: ScreenType): void;
  screenType?: string;
  apiTimeout: string;
};

const CancelReservation = ({
  token,
  lang,
  resId,
  waitListId,
  resType,
  setScreenType,
  screenType,
  apiTimeout
}: Props) => {
  const { localize } = useContext(LocalizationContext);
  const [data, setData] = useState({} as any);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [showConfirmationPage, setShowConfirmationPage] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const reservationService = new ReservationService();
      setIsLoading(true);
      try
      {
        var reservationPayload = await reservationService.getReservation(resId, resType);
        var response = await reservationService.getCancelReservationDetails(
          resId,
          resType,
          reservationPayload
        );
        // var response = await reservationService.getCancelReservationDetailsFake();
        setIsLoading(false);
        setData(response);
        setErrorMessage('');
      } catch (error) {
        setIsLoading(false);
        setErrorMessage('Oops ! Sorry, Something went wrong . Please refresh and retry .')
      }
    }
    fetchData();
  }, []);


  const handleDeleteReservationConfirm = async (deletePayload: any) => {
    const reservationService = new ReservationService();
    setIsLoading(false);
    var response = await reservationService.postCancelReservationDetails(resId, resType, deletePayload);
    let hasMarshaCancellationError = false;
    if (response.cancelReservationResponse.status == 'error') {
      hasMarshaCancellationError = true;
      const errorCode = response.cancelReservationResponse.Error.ErrorCode;
      if (errorCode == 'TSW_CANCEL_MARSHA_CANCELATION') {
        hasMarshaCancellationError = false;
        setShowConfirmationPage(false);
      }else{
        setShowConfirmationPage(true);
        setData({ ...response, hasMarshaCancellationError });
      }
      return response;
    }else{
      setShowConfirmationPage(true);
      setData({ ...response, hasMarshaCancellationError });
      // handle delete success
      setIsLoading(false);
      return response;
    }
  }

  return (
    <div className={`loader-container ${isLoading ? "loading" : ""}`}>
      <MvLoader show={isLoading}>
      <div className="cancel-reservation-container">
        {!showConfirmationPage && errorMessage === '' && <CancelReview
           token={""}
           lang={lang}
           resId={resId}
           resType={resType}
           setScreenType={setScreenType}
           data={data}
           handleDeleteReservationConfirm={handleDeleteReservationConfirm}
        />}
        {showConfirmationPage && errorMessage === '' && <CancelConfirmation
          token={""}
          lang={lang}
          resId={resId}
          resType={resType}
          setScreenType={setScreenType}
          data={data}
          apiTimeout = {apiTimeout}
        />}
        {errorMessage && <div className={`cancel-confirmation-container`}><div className="summary-alert">
          <MvIcon color="#990000" icon="exclamation" width="18px" height="18px" />
          <div>
              {errorMessage}
          </div>
        </div></div>}

      </div>
      </MvLoader>
    </div>
  );
};

export { CancelReservation };
